import { ADD_TO_CART } from "./cartActions";
import Cookies from "js-cookie";

let initialState = {
  items: [],
};

const cookieValue = Cookies.get("paramCart");
if (cookieValue) {
  try {
    const parsedCookieValue = JSON.parse(cookieValue);
    initialState.items = parsedCookieValue.items || [];
  } catch (error) {
    // console.error("Failed to parse cart items from cookie:", error);
  }
}

const setCartCookie = (cartItems) => {
  Cookies.set("paramCart", JSON.stringify({ items: cartItems }), {
    expires: 7,
  });
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART: {
      const existingItemIndex = state.items.findIndex(
        (item) =>
          item.id === action.payload.id &&
          item.price === action.payload.price &&
          item.weight === action.payload.weight,
      );

      let updatedItems;

      if (existingItemIndex !== -1) {
        const updatedItem = {
          ...state.items[existingItemIndex],
          quantity: action.payload.quantity,
        };

        updatedItems = [
          ...state.items.slice(0, existingItemIndex),
          updatedItem,
          ...state.items.slice(existingItemIndex + 1),
        ];
      } else {
        updatedItems = [
          ...state.items,
          {
            id: action.payload.id,
            price: action.payload.price,
            quantity: 1,
            weight: action.payload.weight,
          },
        ];
      }

      updatedItems = updatedItems.filter((item) => item.quantity > 0);
      setCartCookie(updatedItems);

      return { ...state, items: updatedItems };
    }

    default:
      return state;
  }
};

export default cartReducer;
